@import 'styles/mixins';
@import 'styles/blaze/mixins';

.header {
  @include transition;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: fixed;
  z-index: 2;

  [data-autopilot-system-redesign='on'] & {
    border-bottom: 1px solid var(--dark-4);
  }

  .headerContent {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 10px 10px 10px 20px;
    background-color: #f3f5f6;
    position: relative;

    [data-autopilot-system-redesign='on'] & {
      background-color: var(--light-100);
      padding: 14px 20px 14px 14px;
    }

    &.forCrossPost {
      padding: 10px;

      [data-autopilot-system-redesign='on'] & {
        padding: 14px 20px 14px 14px;
      }
    }
  }

  &.isIntersecting {
    background: var(--light-40);
    box-shadow: 0px 3px 15px 0px rgba(0, 0, 0, 0.08);
    backdrop-filter: blur(15px);

    [data-autopilot-system-redesign='on'] & {
      background: var(--light-100);
      box-shadow: none;
      backdrop-filter: none;
    }
  }

  .center {
    display: flex;
    align-items: center;
    overflow: hidden;
    margin: 0 5px;
  }

  .rightCorner {
    display: flex;
    align-items: center;
    gap: 5px;

    a:hover {
      color: var(--dark-80) !important;
    }
  }

  .leftCorner {
    display: flex;
    align-items: center;
    gap: 9px;

    [data-autopilot-system-redesign='on'] & {
      gap: 5px;
    }
  }
}

.platformIconsContainer {
  display: flex;
  align-items: center;
  position: relative;
  width: fit-content;
}

.platformIcon {
  position: relative;
  margin-left: -4px;
  background: #fff;
  border: 1px solid #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  &:first-child {
    margin-left: 0;
  }

  &.hovered {
    background: #e6e6e6;
    border-color: #e6e6e6;
  }

  &.fullScreenPreview {
    background: rgba(243, 245, 246, 0.93);
    border-color: rgba(243, 245, 246, 0.93);
  }
}

.titleContainer {
  display: flex;
  align-items: center;
  gap: 10px;
  width: max-content;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  overflow: hidden;
}

.statusContainer {
  display: flex;
  align-items: center;
  gap: 6px;
}

.hybridAlertIcon {
  background-color: var(--negative-20);
  color: var(--negative-60);
  border-radius: 16px;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: help;
}
